import { calculatePercent } from 'components/progressBars/helpers';
import { curry, __ } from 'ramda';

export const BOUNDARIED_MIN_DEFAULT = 0;
export const BOUNDARIED_MAX_DEFAULT = 100;

export const BOUNDARIED_MIN_SHOW_VALUE = 1;
export const BOUNDARIED_MAX_SHOW_VALUE = 100;

export const PROGRESS_WIDTH_VALUE = [
  BOUNDARIED_MIN_DEFAULT,
  BOUNDARIED_MIN_SHOW_VALUE,
];

export interface ProgressBarProps {
  value: number;
  from: number;
  to: number;
  isRoundDownHighProgress?: boolean;
}

export const boundaryRounding = curry(
  (value: number, boundaries: { min: number; max: number }): number => {
    if (value < boundaries.min) return boundaries.min;
    if (value > boundaries.max) return boundaries.max;
    return value;
  }
);

export const round = (value: number, roundTo: number) =>
  Math.round(value * roundTo) / roundTo;

export const boundariedValueForShowValue = boundaryRounding(__, {
  min: BOUNDARIED_MIN_SHOW_VALUE,
  max: BOUNDARIED_MAX_SHOW_VALUE,
});

export const boundariedValueDefault = boundaryRounding(__, {
  min: BOUNDARIED_MIN_DEFAULT,
  max: BOUNDARIED_MAX_DEFAULT,
});

export const calculateProgress = (
  value: number,
  min: number,
  max: number,
  isRoundDownHighProgress?: boolean
) => {
  if (value == null) return 0;
  if (max == null || value >= max) return 100;

  return calculatePercent(min, max, value, {
    roundTo: 1,
    isRoundDownHighProgress,
  });
};
